import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-129" data-mp="1gd7iadgirj84">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-130" data-mp="2e0fxxrtu9y27">
        <h2 id="faq-title" className="text-center font-serif text-[32px] font-extrabold leading-tight text-ink sm:text-5xl" data-id="element-131" data-mp="2dz4slnkqwi8z">
          Frequently asked <em className="text-brand-600" data-id="element-132" data-mp="2429ydgvi940i">questions</em>
        </h2>

        <div className="mt-10 space-y-3" data-id="element-133" data-mp="240fc9z8hz5uu">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl bg-white shadow-sm" data-id="element-134" data-mp="smv2yhiy2k7i" data-mpi={i}>
                <h3 data-id="element-135" data-mp="no08ujfj1983">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-[17px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-400" data-id="element-136" data-mp="nnifpvo5vb4e">
                    {f.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-137" data-mp="6rq39gbty1kk" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-138" data-mp="1tesn3dpnn1a">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-139" data-mp="3jxq59m5dmhfn">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-muted" data-id="element-140" data-mp="1po1gr5590xcw">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <CtaButton className="mt-12" label="Yes, I want to stop guessing" data-id="element-141" data-mp="2dg8kwqh7u8mv" />
      </div>
    </section>;
}